import { render, staticRenderFns } from "./ResidentDetail.vue?vue&type=template&id=ca1894ea&scoped=true&lang=pug"
import script from "./ResidentDetail.vue?vue&type=script&lang=ts"
export * from "./ResidentDetail.vue?vue&type=script&lang=ts"
import style0 from "./ResidentDetail.vue?vue&type=style&index=0&id=ca1894ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1894ea",
  null
  
)

export default component.exports